import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HomeMultiPage} from './home-multi.page';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {VideoChatModule} from "../video-chat/video-chat.module";
import {SkeletonJourneyComponent} from './skeleton/skeleton-journey.component';
import {PipesModule} from '../../pipes/pipes.module';
import {MomentModule} from 'ngx-moment';
import {SearchWidgetComponent} from './components/search-widget/search-widget.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule.forChild(),
        RouterModule.forChild([
            {
                path: '',
                component: HomeMultiPage
            },
            {
                path: ':journey',
                component: HomeMultiPage
            }
        ]),
        ComponentsModule,
        VideoChatModule,
        PipesModule,
        MomentModule
    ],
    declarations: [
      HomeMultiPage,
      SkeletonJourneyComponent,
      SearchWidgetComponent
    ]
})
export class HomeMultiModule {
}
